import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../../context/ToastContext";

export const useQuestionBank = ({ questions, setQuestions, surveyQuestions }) => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [showPopUp, setShowPopup] = useState({ show: false, data: {} });
    const [options, setOptions] = useState({});
    const [activeIndex, setActiveIndex] = useState(null);
    const [selectedQuestions, setSelectedQuestions] = useState({ value: { questions: {}, category: {} }, category_wise: {} });
    const [categorySelectAll, setCategorySelectAll] = useState({});
    const [faqData, setFaqData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [confirmationPopup, setConfirmationPopup] = useState({ type: "", show: false, data: "" })
    const [filterValue, setFilterValue] = useState({ type: {} });
    const tagRef = useRef(null);
    const [questionList, setQuestionList] = useState([]);
    const [isExpanded, setIsExpanded] = useState(true)


    useEffect(() => {
        setQuestionList(surveyQuestions ? surveyQuestions : faqData);
    }, [faqData])

    useEffect(() => {
        callautopopulate("question_category", "question_type", "rating_symbols").then((res) => {
            setOptions({ category: _.sortBy(res?.question_category, "question_category_name"), types: res?.question_type, symbol: _.sortBy(res?.rating_symbols, "rating_symbol_name"), apiCall: true });
        });
        return () => {
            sessionStorage.removeItem("question_category")
        }
    }, []);

    useEffect(() => {
        isExpanded ? setActiveIndex(Array.from({ length: faqData?.length }, (_, index) => index)) : setActiveIndex([])
    }, [isExpanded])

    useEffect(() => {
        options?.apiCall && fetchQuestionsByCategory("");
    }, [options?.apiCall])

    useEffect(() => {
        if (!_.isEmpty(questions)) {
            if (!_.isEqual(selectedQuestions?.value, questions)) {
                setSelectedQuestions((prev) => ({ ...prev, value: { ...prev?.value, ...questions } }));
            }
        } else {
            setSelectedQuestions((prev) => ({ ...prev, value: { questions: {}, category: {} }, category_wise: {} }));
        }
    }, [questions])

    useEffect(() => {
        let category = { ...questions?.category };
        questionList?.forEach((item) => {
            let count = 0;
            if (!_.isEmpty(questions)) {
                item?.questions?.forEach((ques) => {
                    if (_.pluck(questions?.questions, "question_id")?.includes(ques?.question_id)) {
                        count++;
                    }
                })
            }

            if (category?.[item?.id]) {
                category[item?.id]["all_quest"] = _.pluck(item?.questions, "question_id");
            }
            setCategorySelectAll((prev) => ({ ...prev, [item?.category]: (count === item?.questions?.length && count > 0) ? true : false }));
            setSelectedQuestions((prev) => ({ ...prev, category_wise: { ...prev?.category_wise, [item?.category]: count } }))
        })
    }, [questionList, questions])

    const fetchQuestionsByCategory = async (question_title) => {
        setLoading(true);
        try {
            const payload = {
                question_category_id: _.pluck(filterValue?.category, "question_category_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote('POST', Urls('GETQUESTIONDEAILLIST'), payload);
            if (res?.body?.data?.question_list_details) {
                const questionDetails = _.sortBy(res.body.data.question_list_details, "order_number");
                const categoryKeys = _.uniq(_.pluck(questionDetails, "question_category_key"));
                const faqData = categoryKeys.map(key => ({
                    name: _.find(questionDetails, { question_category_key: key })?.question_category_name,
                    id: _.find(questionDetails, { question_category_key: key })?.question_category_id,
                    category: key,
                    category_display_name: _.find(questionDetails, { question_category_key: key })?.question_category_display_name,
                    questions: _.filter(questionDetails.map(question => {
                        const surveyUsage = _.filter(res?.body?.data?.survey_usage_list, { question_id: question.question_id });
                        return { ...question, survey_usage: surveyUsage };
                    }), { question_category_key: key })
                }));
                setFaqData(faqData);
                setActiveIndex(Array.from({ length: faqData?.length }, (_, index) => index));
                setLoading(false);
                const newQuest = _.findWhere(questionDetails, { question_title: question_title });
                if (question_title) {
                    let selected = { ...selectedQuestions?.value?.questions };
                    selected[newQuest?.question_id] = { question_id: newQuest?.question_id, question_order_number: newQuest?.order_number };
                    setQuestions((prev) => ({ ...prev, questions: selected }));
                    setSelectedQuestions((prev) => ({ ...prev, value: { ...prev?.value, questions: selected } }));
                }
            } else {
                setFaqData([]);
                setLoading(false);
            }
        } catch (error) {

            setFaqData([]);
            setLoading(false);
        }
    };

    const handleQuestionSelect = (question, selectAll, value) => {
        let selected = { ...selectedQuestions?.value?.questions };
        let selectedCategory = { ...selectedQuestions?.value?.category };
        let count = selectedQuestions?.category_wise?.[question?.question_category_key];
        if (!selectAll) {
            if ((_.pluck(Object.values(selected), "question_id"))?.includes(question?.question_id)) {
                delete selected[question?.question_id];
                count--;
                if (count === 0 && selectedCategory?.[question?.question_category_id]) {
                    delete selectedCategory[question?.question_category_id];
                }
                setCategorySelectAll((prev) => ({ ...prev, [question?.question_category_key]: false }));
            } else {
                selected[question?.question_id] = {
                    question_id: question?.question_id,
                    question_order_number: question?.order_number || 0,
                };
                count++;
                if (count === _.findWhere(questionList, { category: question?.question_category_key })?.questions?.length) {
                    setCategorySelectAll((prev) => ({ ...prev, [question?.question_category_key]: true }));
                } else if (count === 1) {
                    selectedCategory[question?.question_category_id] = {
                        question_category_id: question?.question_category_id,
                        category_order_number: 0,
                        all_quest: [question?.question_id]
                    };
                }
            }

        } else {
            const quests = _.findWhere(questionList, { category: question })?.questions;
            quests?.forEach(item => {
                if (value) {
                    selected[item?.question_id] = {
                        question_id: item?.question_id,
                        question_order_number: item?.order_number || 0,
                    }
                } else {
                    selected[item?.question_id] = {}
                }
            })
            const category_id = _.findWhere(options?.category, { question_category_key: question })?.question_category_id;
            if (value) {
                if (!selectedCategory?.[category_id]) {
                    selectedCategory[category_id] = {
                        question_category_id: category_id,
                        category_order_number: 0,
                    };
                }
            } else {
                if (selectedCategory?.[category_id]) {
                    delete selectedCategory[category_id];
                }
            }
            count = value ? quests?.length : 0
            setCategorySelectAll((prev) => ({ ...prev, [question]: value || false }));
        }
        setQuestions({ ...selectedQuestions?.value, questions: selected, category: selectedCategory });
        setSelectedQuestions((prev) => ({ ...prev, value: { ...prev?.value, questions: selected, category: selectedCategory }, category_wise: { ...prev?.category_wise, [selectAll ? question : question?.question_category_key]: count } }));

    };


    const handleOrderNumberChange = (e, question, categoryEdit) => {
        let value = e.target.value;
        if (_.isNaN(value)) {
            return;
        }
        let selected = { ...selectedQuestions?.value?.questions };
        let category = { ...selectedQuestions?.value?.category };
        if (categoryEdit) {
            category[question?.id] = { question_category_id: question?.id, category_order_number: (e.target.value ? parseInt(e.target.value) : ""), all_quest: _.pluck(question?.questions, "question_id") };
        } else {
            selected[question?.question_id] = { question_id: question?.question_id, question_order_number: (e.target.value ? parseInt(e.target.value) : "") };
        }
        setQuestions({ ...selectedQuestions?.value, questions: selected, category: category });
        setSelectedQuestions((prev) => ({ ...prev, value: { ...prev?.value, questions: selected, category: category } }));
    }

    const handleDelete = async () => {
        try {
            const payload = {
                "question_id": confirmationPopup?.data?.question_id
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEQUESTIONDETAIL"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
            } else if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setConfirmationPopup({ type: "", show: false, id: "" })
                fetchQuestionsByCategory()
            } else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleDuplicate = async () => {
        try {
            const newTitle = confirmationPopup?.newValue?.trim();
            if (!newTitle) {
                showInfo('Info', 'Title cannot be empty.');
                return;
            }
            if (newTitle.toLowerCase() === confirmationPopup?.data?.question_title?.trim()?.toLowerCase()) {
                showInfo('Info', 'New title cannot be the same as the original title.');
                return;
            }
            const payload = {
                "question_id": confirmationPopup?.data?.question_id,
                "question_title": confirmationPopup?.newValue
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEQUESTIONDETAILCOPY"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
            } else if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                fetchQuestionsByCategory();
                setConfirmationPopup({ type: "", show: false, data: "" })
            } else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getSortedQuestions = useCallback((categoryIndex) => {
        const category = surveyQuestions ? surveyQuestions[categoryIndex] : faqData[categoryIndex];
        const sortCon = sortConfig[categoryIndex] || { key: null, direction: 'asc' };

        if (!category?.questions || sortCon.key === null) {
            return category?.questions || [];
        }

        return [...category.questions].sort((a, b) => {
            const aValue = a[sortCon.key] || '';
            const bValue = b[sortCon.key] || '';

            if (sortCon.key === 'used') {
                const aNum = parseInt(aValue) || 0;
                const bNum = parseInt(bValue) || 0;
                return sortCon.direction === 'asc' ? aNum - bNum : bNum - aNum;
            }

            const aStr = aValue.toString().toLowerCase();
            const bStr = bValue.toString().toLowerCase();
            return sortCon.direction === 'asc'
                ? aStr.localeCompare(bStr)
                : bStr.localeCompare(aStr);
        });
    }, [faqData, sortConfig]);


    const handleSort = (categoryIndex, key) => {
        setSortConfig(prev => {
            const current = prev[categoryIndex] || { key: null, direction: 'asc' };

            if (current.key !== key) {
                return { ...prev, [categoryIndex]: { key, direction: 'asc' } };
            }

            return {
                ...prev,
                [categoryIndex]: {
                    key,
                    direction: current.direction === 'asc' ? 'desc' : 'asc'
                }
            };
        });
    };

    return useMemo(() => ({
        showPopUp, setShowPopup, options, setOptions, activeIndex, setActiveIndex, selectedQuestions, categorySelectAll, handleQuestionSelect, faqData, fetchQuestionsByCategory, loading, filterValue, setFilterValue, confirmationPopup, setConfirmationPopup, handleDelete, handleDuplicate, getSortedQuestions, handleSort, tagRef, questionList, handleOrderNumberChange, isExpanded, setIsExpanded
    }), [showPopUp, setShowPopup, options, setOptions, activeIndex, setActiveIndex, selectedQuestions, categorySelectAll, handleQuestionSelect, faqData, confirmationPopup, setConfirmationPopup, fetchQuestionsByCategory, loading, filterValue, setFilterValue, handleDelete, handleDuplicate, getSortedQuestions, handleSort, , tagRef, questionList, handleOrderNumberChange, isExpanded, setIsExpanded]);
};








